(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gusto-all-products"] && !Shopify.designMode) return;
  try {
    
  if (!window.gustoProductGalleryBound) {
    window.gustoProductGalleryBound = true;

    document.addEventListener('click', (event) => {
      const thumbnail = event.target.closest('[data-product-thumbnail]');
      if (!thumbnail) return;

      event.preventDefault();
      event.stopPropagation();

      const card = thumbnail.closest('.gusto-product');
      const mainImage = card && card.querySelector('.gusto-product__media img');
      if (!mainImage) return;

      mainImage.src = thumbnail.dataset.imageUrl;
      mainImage.srcset = thumbnail.dataset.imageSrcset;

      if (thumbnail.dataset.variantId) {
        const variantInput = card.querySelector('.product-variant-id');
        const price = card.querySelector('[data-price]');
        const submitButton = card.querySelector('.product-form__submit');
        const submitButtonLabel = submitButton && submitButton.querySelector('span');
        const isAvailable = thumbnail.dataset.variantAvailable === 'true';

        if (variantInput) {
          variantInput.value = thumbnail.dataset.variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (price) price.textContent = thumbnail.dataset.variantPrice;
        if (submitButton) submitButton.disabled = !isAvailable;
        if (submitButtonLabel) {
          submitButtonLabel.textContent = isAvailable
            ? submitButton.dataset.addToCartText
            : submitButton.dataset.soldOutText;
        }
      }

      card.querySelectorAll('[data-product-thumbnail]').forEach((button) => {
        const active = button === thumbnail;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gusto-business-services"] && !Shopify.designMode) return;
  try {
    
  if (!window.gustoProductGalleryBound) {
    window.gustoProductGalleryBound = true;

    document.addEventListener('click', (event) => {
      const thumbnail = event.target.closest('[data-product-thumbnail]');
      if (!thumbnail) return;

      event.preventDefault();
      event.stopPropagation();

      const card = thumbnail.closest('.gusto-product');
      const mainImage = card && card.querySelector('.gusto-product__media img');
      if (!mainImage) return;

      mainImage.src = thumbnail.dataset.imageUrl;
      mainImage.srcset = thumbnail.dataset.imageSrcset;

      card.querySelectorAll('[data-product-thumbnail]').forEach((button) => {
        const active = button === thumbnail;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gusto-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFaq = (scope = document) => {
      scope.querySelectorAll('.gusto-faq__items').forEach((group) => {
        if (group.dataset.gustoFaqReady === 'true') return;
        group.dataset.gustoFaqReady = 'true';

        const setItemState = (item, shouldOpen) => {
          const trigger = item.querySelector('.gusto-faq__trigger');
          const panel = item.querySelector('.gusto-faq__answer-reveal');

          item.classList.toggle('is-open', shouldOpen);
          trigger.setAttribute('aria-expanded', String(shouldOpen));
          panel.setAttribute('aria-hidden', String(!shouldOpen));
        };

        group.querySelectorAll('.gusto-faq__trigger').forEach((trigger) => {
          trigger.addEventListener('click', () => {
            const selectedItem = trigger.closest('.gusto-faq__item');
            const shouldOpen = !selectedItem.classList.contains('is-open');

            group.querySelectorAll('.gusto-faq__item').forEach((item) => {
              setItemState(item, item === selectedItem && shouldOpen);
            });
          });
        });
      });
    };

    initializeFaq();
    document.addEventListener('shopify:section:load', (event) => initializeFaq(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gusto-special-offers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gusto-offer-countdown')) {
    customElements.define(
      'gusto-offer-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.deadline = Date.parse(this.dataset.deadline);
          this.nodes = {
            days: this.querySelector('[data-days]'),
            hours: this.querySelector('[data-hours]'),
            minutes: this.querySelector('[data-minutes]'),
            seconds: this.querySelector('[data-seconds]')
          };
          this.update();
          if (Number.isFinite(this.deadline) && this.deadline > Date.now()) {
            this.interval = window.setInterval(() => this.update(), 1000);
          }
        }

        disconnectedCallback() {
          window.clearInterval(this.interval);
        }

        update() {
          const remaining = Number.isFinite(this.deadline) ? Math.max(0, this.deadline - Date.now()) : 0;
          const values = {
            days: Math.floor(remaining / 86400000),
            hours: Math.floor((remaining % 86400000) / 3600000),
            minutes: Math.floor((remaining % 3600000) / 60000),
            seconds: Math.floor((remaining % 60000) / 1000)
          };

          Object.entries(values).forEach(([key, value]) => {
            if (this.nodes[key]) this.nodes[key].textContent = String(value).padStart(2, '0');
          });

          if (remaining === 0) window.clearInterval(this.interval);
        }
      }
    );
  }

  if (!window.gustoProductGalleryBound) {
    window.gustoProductGalleryBound = true;

    document.addEventListener('click', (event) => {
      const thumbnail = event.target.closest('[data-product-thumbnail]');
      if (!thumbnail) return;

      event.preventDefault();
      event.stopPropagation();

      const card = thumbnail.closest('.gusto-product');
      const mainImage = card && card.querySelector('.gusto-product__media img');
      if (!mainImage) return;

      mainImage.src = thumbnail.dataset.imageUrl;
      mainImage.srcset = thumbnail.dataset.imageSrcset;

      card.querySelectorAll('[data-product-thumbnail]').forEach((button) => {
        const active = button === thumbnail;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  if (!window.gustoProductGalleryBound) {
    window.gustoProductGalleryBound = true;

    document.addEventListener('click', (event) => {
      const thumbnail = event.target.closest('[data-product-thumbnail]');
      if (!thumbnail) return;

      event.preventDefault();
      event.stopPropagation();

      const card = thumbnail.closest('.gusto-product');
      const mainImage = card && card.querySelector('.gusto-product__media img');
      if (!mainImage) return;

      mainImage.src = thumbnail.dataset.imageUrl;
      mainImage.srcset = thumbnail.dataset.imageSrcset;

      card.querySelectorAll('[data-product-thumbnail]').forEach((button) => {
        const active = button === thumbnail;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
